import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CadViewerCanvasComponent } from '../components/cad-viewer/cad-viewer-canvas/cad-viewer-canvas.component';
import { CadDrawingListComponent } from '../components/cad-viewer/cad-drawing-list/cad-drawing-list.component';
import { CadDrawing } from '../shared/services/cad-viewer.service';

@Component({
  selector: 'app-cadviewer',
  standalone: true,
  imports: [CommonModule, CadViewerCanvasComponent, CadDrawingListComponent],
  templateUrl: './cadviewer.component.html',
  styleUrls: ['./cadviewer.component.css'],
})
export class CadviewerComponent {
  selected: CadDrawing | null = null;
  private autoSelected = false;

  onSelect(drawing: CadDrawing): void {
    this.selected = drawing;
  }

  onDrawingsChange(drawings: CadDrawing[]): void {
    if (this.selected && !drawings.some((d) => d.id === this.selected!.id)) {
      this.selected = null;
    }
    if (!this.autoSelected && !this.selected && drawings.length) {
      this.autoSelected = true;
      this.selected = drawings[0];
    }
  }
}
